import { render, staticRenderFns } from "./PrintButton.vue?vue&type=template&id=1bb8af9e"
import script from "./PrintButton.vue?vue&type=script&lang=ts"
export * from "./PrintButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\ldemenego\\REPOS\\VUEJS\\configuratore-demenego-v2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb8af9e')) {
      api.createRecord('1bb8af9e', component.options)
    } else {
      api.reload('1bb8af9e', component.options)
    }
    module.hot.accept("./PrintButton.vue?vue&type=template&id=1bb8af9e", function () {
      api.rerender('1bb8af9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/buttons/PrintButton.vue"
export default component.exports